module.exports = __webpack_public_path__ + "img/xlmup.72333ee6.svg";